<template>
  <v-container>
    <v-card class="mx-auto" flat>
      <v-row>
        <v-col>
          <p class="headline font-weight-bold" style="color:#AF8936; font-size: 27px !important;">
            Reporte de Sentencias
          </p>
        </v-col>
      </v-row>
      <v-divider class="mb-9"></v-divider>
      <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col class="mt-n7" cols="12" v-if="role_id != 3">
            <v-select
              :rules="[v => !!v || 'Seleccione una sala']"
              :items="listSalas"
              v-model="sala_id"
              label="Sala"
              item-value="id"
              item-text="nombre"
              dense
              outlined
              @change="showReporte = false"
            >
            </v-select>
          </v-col>
          <v-col class="mt-n7" cols="6" md="6">
            <v-menu
              ref="dialogFecInicio"
              v-model="dialogFecInicio"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :rules="[v => !!v || 'Seleccione fecha inicial']"
                  v-model="fecha_inicio"
                  label="Fecha Inicial"
                  prepend-icon="mdi-calendar-outline"
                  readonly
                  v-on="on"
                  dense
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha_inicio"
                @input="dialogFecInicio = false"
                locale="es-mx"
                min="2010-01-01"
                :max="new Date().toISOString().substr(0, 10)"
                @change="calculateFechaFin()"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="mt-n7" cols="6" md="6">
            <v-menu
              ref="dialogFecInicio"
              v-model="dialogFecFin"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :rules="[v => !!v || 'Seleccione fecha final']"
                  v-model="fecha_fin"
                  label="Fecha Final"
                  prepend-icon="mdi-calendar-outline"
                  readonly
                  v-on="on"
                  dense
                  outlined
                  :disabled="disabledFechaFin"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha_fin"
                @input="dialogFecFin = false"
                locale="es-mx"
                :min="fecha_inicio"
                :max="maxFechaFin"
                @change="showReporte = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col cols="12">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#616161" class="white--text mt-n9" @click.native="validate()" :loading="loading"> Buscar </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>

      <div v-if="showReporte">
        <v-row>
          <v-col>
            <p class="overline">Resultados de la consulta</p>
          </v-col>
          <v-spacer></v-spacer>
          <v-col style="color:#AF8936" align="right" class="mr-3">
            <h4 >Total: {{tocasTotal}}</h4>
          </v-col>
        </v-row>
        <v-row class="mt-n6">
          <v-spacer></v-spacer>
          <v-btn v-if="listTocas.length" dark color="#616161" @click="reportePdf()" class="mr-3">
            <v-icon>mdi-file-pdf</v-icon>ver reporte
          </v-btn>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              dense
              :headers="headers"
              :items="listTocas"
              item-value="id"
              item-text="numero"
              class="elevation-1"
              :loading="loading"
              light
              actions
              hide-default-footer
              disable-pagination
              no-data-text="No se encontraron sentencias publicadas"
              elevation="7"
            >
            <template v-slot:item.toca = "{item}">
              <td>{{ item.numero }}-{{ item.periodo}}</td>
            </template>
            <template v-slot:item.sala = "{item}">
              <td>SALA {{ item.salas_data.id }}</td>
            </template>
            <template v-slot:item.url = "{item}">
              {{ path + '/getfile/'+ item.id }}
            </template>
          </v-data-table>
          </v-col>
        </v-row>
      </div>
      <v-dialog
        v-model="progressLoading"
        persistent
        width="300"
      >
        <v-card
          color="#AF8936"
          dark
        >
          <v-card-text>
            <b>DESCARGANDO REPORTE...</b>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
const Swal = require('sweetalert2');
  export default {
    data: () => ({
      path: process.env.VUE_APP_PATH_DOWNLOAD,
      progressLoading: false,
      dialogFecInicio: false,
      dialogFecFin: false,
      fecha_inicio: '',
      fecha_fin:'',
      disabledFechaFin: true,
      maxFechaFin:'',
      showReporte: false,
      tocasTotal:'',
      valid: true,
      sala_id:'',
      role_id:'',
      dialog: false,
      loading:false,
      headers: [
        { text: 'Toca', value: 'toca', sortable: false  },
        { text: 'Sala', value: 'sala' },
        { text: 'Url descarga', value: 'url' },
        { text: 'Fecha de Publicación', value: 'fecha_publicacion' },
      ],
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }),
    computed:{
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Publicación' : 'Editar Publicación'
      },
      ...mapGetters([
        "listTocas", "listSalas", "currentUser"
      ])
    },
    mounted(){
      this.getSalas()
      this.role_id = this.currentUser.roles[0].id
    },
    methods:{
      calculateFechaFin(){
        this.showReporte = false
        var today = new Date().toISOString().substr(0, 10)
        var date = new Date(this.fecha_inicio);
        date.setMonth(date.getMonth() + 1)
        if (date.toISOString().substr(0, 10) > today) {
          this.fecha_fin = today;
          this.maxFechaFin = today;
        } else {
          this.fecha_fin = date.toISOString().substr(0, 10);
          this.maxFechaFin = date.toISOString().substr(0, 10);
        }
        this.disabledFechaFin = false
      },
      getSalas() {
        this.loading = true;
        this.$store.dispatch("GET_SALAS",  { url: "/salas" } ).then(response => {
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.loading = true
          this.buscar()
        }
      },
      buscar() {
        this.loading = true;
        this.$store.dispatch("GET_TOCAS_REPORTE", { url:"/tocas",
          data: {
            fecha_ini: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            sala_id: this.sala_id || this.currentUser.sala_data.id,
            paginador: 2
          }
        })
        .then((response) => {
          this.tocasTotal = this.listTocas.length
          this.loading = false
          this.showReporte = true
        })
        .catch(error => {
          console.log(error);
        });
      },
      reportePdf(){
        this.progressLoading = true
        this.$store.dispatch("GET_PDF", { url:"/tocas/reportePDF",
          data: {
            fecha_ini: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            sala_id: this.sala_id || this.currentUser.sala_data.id,
          }
        }).then((response) => {
          this.progressLoading = false
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          let inicio = this.fecha_inicio
          let fin = this.fecha_fin
          link.setAttribute('download', 'Reporde de ' + inicio +' al '+ fin +'.pdf');
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.log(err);
          this.progressLoading = false
          this.$swal({
            title: 'Error al descargar el PDF!!!',
            icon: 'error',
            timer: 1000,
          })
        });
      }
    }
  }
</script>
